import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import Button from "../../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../../Reusable/BaseURL";
import { IndentSelect } from "../../../Reusable/IndentSelect";
import IndentStatusView from "../../../purchaseFormPages/IndentStatusView";
import { PartySelect } from "../../../Reusable/PartySelect";
import { Link, useNavigate } from "react-router-dom";
import { QuotationIndentSelect } from "./QuotationIndentSelect";
import { QuotationPartySelect } from "./QuotationPartySelect";
import QuotationPageForm from "./QuotationPageForm";
import MyInput from "../../../Reusable/MyInput";

export default function Quotation() {
  const { darkTheme, loginData, setIndentCreateItemId4Upd } =
    useContext(UserContext);

  const [indent, setIndent] = useState("");
  const [date, setDate] = useState("");
  const [quotationNo, setQuotationNo] = useState("");
  const [party, setParty] = useState("");
  // const [indentId, setIndentId] = useState(null)
  const [negoAmountTotal, setNegoAmountTotal] = useState(0);
  const [getQuotationItem, setGetQuotationItem] = useState([]);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(false);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);

  const navigate = useNavigate();

  // TODAY CURRENT DATE DEFAULT SET
  const currentDateFunc=()=>{
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    return setDate(formattedDate);
  }

  useEffect(()=>{
    currentDateFunc()
  },[])

  const getQuotation = async (e, partyId, indentId) => {
    e.preventDefault();
    setGetQuotationItem([]);
    setSpinner(true);
    const response = await fetch(
      `${BaseURL}/purchase/quotation/getquotation?indent_id=${indentId}&party_id=${partyId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status) {
      setSpinner(false);
      setGetQuotationItem(data.data.quotation_items);
      calcNegotiationAmountTotal(getQuotationItem);
    }
    if (data.status === false) {
      toast.error("Indent and Party Required");
      setSpinner(false);
    }
  };

  function calcNegotiationAmountTotal(data) {
    let negotiationTotal = 0;
    data.forEach((item, index) => {
      negotiationTotal += parseFloat(item.negotiation_amount);
    });
    setNegoAmountTotal(negotiationTotal);
  }
  useEffect(() => {
    calcNegotiationAmountTotal(getQuotationItem);
  }, [getQuotationItem]);

  // create
  async function submitQuotationItems(e) {
    e.preventDefault();
    setSubmitDisable(true);
    const formData = {
      indent_id: indent.value,
      party_id: party.value,
      quotations: getQuotationItem,
      quotation_sum_amount: negoAmountTotal,
      quotation_no: quotationNo,
      date: date,
    };
    console.log({ quotations: formData });

    const res = await fetch(`${BaseURL}/purchase/quotation/save`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          toast.success("Success");
          setGetQuotationItem([]);
          setParty("");
          // setIndent("");
          navigate("/purchase/view-quotation");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          toast.error("Submition error");
          setSubmitDisable(false);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(id) {
    fetch(`${BaseURL}/purchase/indent/getcacheitem/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          setChangingSelect(true);
          setSubmitAction("update");

          // setDivision(selectedRecord.data.division || "");
        }
      });
    setChangingSelect(false);
  }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setGetQuotationItem([]);
    setParty("");
    setIndent("");
  }
  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Quotation
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col gap-8 md:gap-1 lg:gap-4"
          >
            <div className="px-2 mb-6 flex flex-col w-full flex-wrap">
              <div>
                <form>
                  <div className="flex flex-row flex-wrap gap-x-2 md:gap-x-6 gap-y-2">
                    <div className="mb-2 min-w-[260px] max-w-[460px]">
                      <label>
                        Indent <span className="text-red-500 font-bold">*</span>
                      </label>
                      <QuotationIndentSelect
                        selectedOption={indent}
                        setSelectedOption={setIndent}
                        changingSelect={changingSelect}
                        cancelUpdate={cancelUpdate}
                        setGetQuotationItem={setGetQuotationItem}
                        getQuotationItem={getQuotationItem}
                        setParty={setParty}
                        party={party}
                      />
                    </div>

                    <div className="flex flex-wrap gap-2">
                      <div className="min-w-[260px] max-w-[460px]">
                        <label>
                          Party{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <QuotationPartySelect
                          selectedOption={party}
                          setSelectedOption={setParty}
                          changingSelect={changingSelect}
                          indentId={indent && indent.value}
                        />
                      </div>
                    </div>
                    <div>
                      <button
                        onClick={(e) => getQuotation(e, party.value, indent.value)}
                        className="bg-green-600 rounded-md px-4 py-2 text-white mt-5 ml-3"
                      >
                        Load
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              {/* After LOAD btn click  */}
              {getQuotationItem.length > 0 && (
                <div className="flex flex-col gap-2 md:gap-6 md:flex-row mt-3">
                  <MyInput
                    label="Quotation No."
                    type="text"
                    value={quotationNo}
                    onChange={(e) => setQuotationNo(e.target.value)}
                    className="w-[260px] md:w-[300px] lg:w-[360px] block"
                    mendatory="*"
                  />

                  <div className="mb-2 w-full">
                    <label className="mr-2 block mb-[4px]">
                      Date <span className="text-red-500 font-bold">*</span>
                    </label>
                    <input
                      className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                        darkTheme
                          ? "bg-gray-700 border-gray-500"
                          : "bg-white border-gray-500"
                      }`}
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      type="date"
                      name="date"
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="w-full px-2">
              <QuotationPageForm
                editBtn={editBtn}
                // firstPageList={firstPageList}
                links={links}
                firstPage={getQuotationItem}
                setFirstPage={setGetQuotationItem}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                addMoreToggle={addMoreToggle}
                setAddMoreToggle={setAddMoreToggle}
                negoAmountTotal={negoAmountTotal}
                setNegoAmountTotal={setNegoAmountTotal}
                calcNegotiationAmountTotal={calcNegotiationAmountTotal}
              />
            </div>

            {submitAction === "submit" && (
              <div className="flex items-center justify-center gap-x-1 mt-2">
                <Button
                  disabled={submitDisable}
                  type="submit"
                  onClick={(e) => submitQuotationItems(e)}
                >
                  {submitDisable ? "Wait.." : "Send"}
                </Button>
                <Button type="button" onClick={() => cancelUpdate()}>
                  Clear
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
